export default __webpack_public_path__ + "static/media/menu.53b15312.svg";